// ====================================================================================
// readMoreMarker.module
// ====================================================================================
import $ from "jquery";

export const init = () => {
  // read-more Klapperfunktion mit ###weiterlesen### marker
  let readMores = document.querySelectorAll(".read-more-marker");
  let headerHeight = $(".header").height();

  readMores.forEach((readMore) => {
    let $readMoreMarker = $(readMore);
    let $readMoreText = $readMoreMarker.nextAll();
    let offsetTop = $readMoreMarker.offset().top - headerHeight - 100;

    $readMoreMarker.html(
      '<div class="text-center">\n' +
        '    <button class="btn btn--more" title="weiterlesen">\n' +
        "            <span>&hellip;</span><span>weiterlesen</span>\n" +
        "    </button>\n" +
        "</div>"
    );

    $readMoreText.hide();

    $readMoreMarker
      .parent()
      .append(
        '<div class="read-less-marker"><div class="text-center">\n' +
          '    <button class="btn btn--more" title="weniger anzeigen">\n' +
          "            <span>&hellip;</span><span>weniger anzeigen</span>\n" +
          "    </button>\n" +
          "</div></div>"
      );

    $readMoreMarker.parent().find(".read-less-marker").hide();
    //$('.read-more').parent().nextAll().css( "background-color", "red" );

    $readMoreMarker.on("click", function () {
      $readMoreText.slideDown();
      $(this).hide();
      $(this).parent().parent().find(".read-less-marker").show();
    });

    $readMoreMarker
      .parent()
      .find(".read-less-marker")
      .on("click", function (e) {
        let $this = $(this);
        $("html, body").animate({ scrollTop: offsetTop }, 400);
        $readMoreText.slideUp(400, function () {
          $this.hide();
          $this.parent().find(".read-more-marker").show();
        });
      });
  });
};
